var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio_call_Icon",
    "data-name": "Audio call Icon",
    transform: "translate(11464 -4828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1",
    "data-name": "Shape 1",
    d: "M328.217,251.981a18.649,18.649,0,0,0,6.206,4.843,9.686,9.686,0,0,0,3.473,1.024c.084,0,.164.007.248.007a2.881,2.881,0,0,0,2.23-.955.079.079,0,0,0,.015-.018,9.39,9.39,0,0,1,.7-.726c.171-.163.346-.334.514-.508a1.749,1.749,0,0,0-.007-2.61l-2.19-2.182a1.776,1.776,0,0,0-1.283-.588,1.836,1.836,0,0,0-1.3.585l-1.3,1.3c-.12-.069-.244-.131-.361-.189a4.478,4.478,0,0,1-.4-.218,13.787,13.787,0,0,1-3.3-2.992,7.918,7.918,0,0,1-1.115-1.772c.343-.309.663-.632.973-.948.109-.113.222-.225.335-.338a1.714,1.714,0,0,0,0-2.614L330.572,242c-.128-.127-.248-.251-.372-.378-.24-.247-.492-.5-.74-.73a1.82,1.82,0,0,0-1.283-.559,1.874,1.874,0,0,0-1.3.563l-1.363,1.358a2.786,2.786,0,0,0-.835,1.786,6.7,6.7,0,0,0,.507,2.9A16.887,16.887,0,0,0,328.217,251.981Zm-2.646-7.864a1.918,1.918,0,0,1,.579-1.234l1.356-1.351a.983.983,0,0,1,.671-.309.933.933,0,0,1,.656.316c.244.225.474.461.721.712.124.127.251.254.379.385l1.086,1.082a.844.844,0,0,1,0,1.358c-.113.113-.226.229-.339.341-.339.341-.656.664-1.006.973l-.018.018a.708.708,0,0,0-.182.806c0,.011.007.018.011.029a8.536,8.536,0,0,0,1.279,2.073,14.555,14.555,0,0,0,3.513,3.188,5.212,5.212,0,0,0,.481.261,4.534,4.534,0,0,1,.4.218l.04.022a.764.764,0,0,0,.353.091.774.774,0,0,0,.543-.247l1.363-1.358a.966.966,0,0,1,.667-.323.916.916,0,0,1,.645.323l2.2,2.186a.873.873,0,0,1-.011,1.369c-.153.163-.313.32-.485.483a10.453,10.453,0,0,0-.762.788,2,2,0,0,1-1.563.661c-.062,0-.128,0-.19-.007a8.8,8.8,0,0,1-3.142-.937,17.716,17.716,0,0,1-5.908-4.611,16.163,16.163,0,0,1-2.879-4.774A5.836,5.836,0,0,1,325.572,244.117Z",
    transform: "translate(-11784.928 4591.406)",
    fill: "#828282",
    stroke: "#828282",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 24,
    height: 24,
    transform: "translate(-11464 4828)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCall);
export default __webpack_public_path__ + "static/media/audioCall.80aa62da.svg";
export { ForwardRef as ReactComponent };